import React from 'react';
import FormROValue from '../../library/form/components/FormROValue1';
import SarasTrans from '../../library/notifications/SarasTrans';
import FormButton from '../../library/form/components/FormActionButton2';
import FormInput from "../../library/form/components/FormInput";
import * as fn from "../../helper/uiFunctions";

const ReferenceBreakupRow = (props) => {
    const { formObject, rowKey, viewData, index } = props;

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <ul id="uiDPEditLine" >
                <li className="uiColumnCenter uiColumn50">
                    <SarasTrans value={index} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormInput formObject={formObject} rowKey={rowKey}
                        action={{ InputType: "input", paramName: "rbDescp" }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="confirm"
                        onlyIcon={true}
                        tooltip="Confirm Changes"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "save",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="cancel"
                        onlyIcon={true}
                        tooltip="Cancel Changes"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "cancel",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
    else {
        return (
            <ul id="uiDPEditLine" >
                <li className="uiColumnCenter uiColumn50">
                    <SarasTrans value={rowKey} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "rbDescp" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
}

export default ReferenceBreakupRow